<template>
  <div class="header">
      <h1 class="clear">
        <img alt="" :src = "logoImg[0].path">
        <div class="w1">
          <p class="p1" style="text-align: left"><em>李健实验室 </em>: LiJian Research Group</p>
          <p class="p2">高活性松脂基农药分子的合成&nbsp;<em>/ Synthesis of Highly Active Rosin-Based Pesticide Molecules</em></p>
        </div>
        <a class="open" @click="showTab()"></a>
      </h1>
      <div :class="menuClass">
        <a class="close" @click="closeTab()"></a>
        <ul class="clear">
          <li :class="tabClass('Home')" id="n_0">
            <a href="/">Home</a>
          </li>
          <li :class="tabClass('Research')" id="n_1">
            <a href="/research">Research</a>
          </li>
          <li :class="tabClass('Prof. Li')" id="n_2">
            <a href="/prof_li">Prof. Li</a>
          </li>
          <li :class="tabClass('Members')" id="n_3">
            <a href="/members">Members</a>
          </li>
          <li :class="tabClass('Publications')" id="n_4">
            <a href="/publications">Publications</a>
          </li>
          <li :class="tabClass('News')" id="n_5">
            <a href="/news">News</a>
          </li>
          <li :class="tabClass('Photos')" id="n_6">
            <a href="/photos">Photos</a>
          </li>
          <li :class="tabClass('Links')" id="n_7">
            <a href="/links">Links</a>
          </li>
          <li  :class="tabClass('Join Us')" id="n_8">
            <a href="/join-us">Join Us</a>
          </li>
        </ul>
      </div>
    </div>
</template>

<script>

export default {
  name: 'LabHeader',
  props: {
    pageName: {
      type: String,
      default: 'Home'
    }
  },
  data () {
    return {
      navList: [
        {
          title: '首页',
          path: '/index'
        }
      ],
      logoImg: [
        {
          path: require('../../assets/img/logo/logo_wihte.png')
        }
      ],
      logo_img: [
        {
          path: require('../../assets/img/logo/logo_wihte.png')
        },
        {
          path: require('../../assets/img/logo/logo_color.png')
        }
      ],
      logo_font_img: [
        {
          path: require('../../assets/img/logo/logo_white_font.png')
        },
        {
          path: require('../../assets/img/logo/logo_color_font.png')
        }
      ],
      menuClass: 'nav'
    }
  },
  mounted () {
    this.getUserRight()
  },
  methods: {
    getUserRight () {
      this.$axios.post('/server_api/core/admin/get_right', {})
        .then((response) => {
          let res = response.data
          if (res.code === 0) {
            this.right = res.data.right
          } else {
            this.$message.error({
              message: '权限获取失败，请检查token配置',
              duration: 2500
            })
          }
        }).catch((err) => {
          console.log('Error while fetching', err)
          this.$message.error({
            message: '权限获取失败，请检查token配置',
            duration: 2500
          })
        })
    },
    showTab () {
      this.menuClass = 'nav show'
    },
    closeTab () {
      this.menuClass = 'nav'
    },
    tabClass (tabName) {
      if (this.pageName === tabName) {
        return 'active'
      } else {
        return ''
      }
    }
  }
}
</script>
<!--<style>-->
<!--/*<style lang = "less" scoped>*/-->
<!--.body {-->
<!--    background: #eeeeee;-->
<!--}-->
<!--/*@nav_active_color: #307a1c;*/-->
<!--*{margin:0;padding:0;list-style: none;font-family: 'Arial';}-->
<!--.header{background: #00772d;}-->
<!--.header h1{color:#fff;font-weight:normal;padding: 30px 0px;width: 1200px;margin: 0 auto;}-->
<!--.header h1 .w1{float:left;margin:0px 0px 0px 15px;}-->
<!--.header h1 img{max-width: 100%;float:left;}-->
<!--.header .p1{font-size: 28px;line-height: 30px;margin: 7px 0px 5px 0px;}-->
<!--.header .p2{font-size: 16px;font-family: '微软雅黑';}-->
<!--.header .p2 em{font-style:normal;font-size:17px;padding: 0px 0px 0px 5px;/* text-transform:capitalize; */letter-spacing: 0.2px;font-family: 'Arial';}-->
<!--.header .nav{height: 47px;line-height: 47px;background: #018636;}-->
<!--.header .nav ul{width:1200px;margin:0 auto;}-->
<!--.header .nav li{float:left;width: 133px;text-align:center;color:#fff;}-->
<!--.header .nav li a{color:#fff;font-size:16px;display:block;}-->
<!--.header .nav li:hover{background: #378522;}-->
<!--.header .nav li.active{background: #67ad82;}-->
<!--.header .nav li:hover{background: #4ca05a;}-->

<!--.footer{color: #fff;font-size: 12px;text-align: center;background: #307a1c;padding: 20px 0px 15px 0px;line-height: 24px;}-->
<!--.footer a{color:#fff;}-->
<!--.footer .center{width:1200px;margin:0 auto;position:relative;min-height: unset;}-->
<!--.footer .p4{position:absolute;right:0px;bottom: 0px;}-->
<!--.footer a:hover{opacity:0.7;}-->
<!--.footer a:hover{opacity:0.7;}-->
<!--.footer a:hover{opacity:0.7;}-->
<!--.footer .p5{position:absolute;right:0px;bottom: 42px;font-size:18px;}-->
<!--.footer .p5 a{display:inline-block;margin:0px 0px 0px 20px;position: relative;}-->
<!--.footer .p5 a:after{display:block;width:100%;height:1px;background:#fff;content:"";position: absolute;bottom: 1px;}-->
<!--.footer .center .a{width:500px;margin:0 auto;display:block;}-->

<!--.body{background:#eeeeee;}-->
<!--.banner{width:100%;}-->
<!--.banner img{width:100%;max-height: 33vw;}-->
<!--.banner .swiper-pagination .swiper-pagination-bullet{width:30px;height:4px;background:#fff;border-radius:0px;opacity:1;margin:0px 10px;}-->
<!--.Mbanner{display: none;}-->

<!--@media(max-width:1024px){-->
<!--  .banner{display: none}-->
<!--  .Mbanner{display: block;}-->
<!--  .banner img{min-height: 50vw;max-height:unset;}-->
<!--  .banner .swiper-pagination{bottom: 20px;}-->
<!--  .header{height:50px;}-->
<!--  .header h1{padding: 0px 3%;text-align: left;height: 50px;line-height: 47px;width: 94%;}-->
<!--  .header h1 p{display: none;}-->
<!--  .header h1 img{max-width: 50%;max-height: 40px;vertical-align: middle;margin: 0px 0px 0px 10px;float: none;}-->
<!--  .header .open{width: 30px;height: 22px;background: url(../../assets/img/option/menu.png) center center no-repeat;display:block;float:right;margin: 14px 0px 0px 0px;}-->
<!--  .header .nav{width: 100%;height: 100%;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;overflow-y: scroll;background: #307a1c;color: #fff;position: fixed;top: 0px;z-index: 999999;left: -100vw;transition: 1s all ease;}-->
<!--  .header .nav li{float:none;border-bottom:solid 1px #e5e5e5;width:100%;}-->
<!--  .header .nav li:hover{background: #4ca05a;}-->
<!--  .header .nav li.active{background: #4ca05a;}-->
<!--  .header .nav ul{width:100%;margin: 40px auto 0px;}-->
<!--  .header .close{width:20px;height:20px;background:url(../../assets/img/option/close.png) center center no-repeat;display:block;float: right;margin: 10px;}-->
<!--  .header .nav.show{left:0px;}-->
<!--  .footer{height: auto;line-height: 20px;padding: 10px 0px;}-->
<!--  .footer .center{width:96%;}-->
<!--  .footer .center .p4{position:unset;line-height: 30px;}-->
<!--  .footer .p5{position:unset;margin: 0px 0px 5px 0px;}-->
<!--  .footer .center .a{width:100%;}-->
<!--}-->

<!--.el-divider {-->
<!--  background-color: #747474;-->
<!--  position: relative;-->
<!--}-->
<!--html, body, header,footer,div, a, p, ul, ol, li, dl, dt, dd, h1, h2, h3, h4, h5, h6, form, input, select, button, textarea, iframe, table, th, td, blockquote, fieldset { margin:0px; padding:0px;font-family:arial;}-->
<!--img { border:0 none; vertical-align: top;}-->
<!--ul, ol, li { list-style-type: none; }-->
<!--html{font-family:arial; font-size: 14px;}-->
<!--h1, h2, h3, h4, p, span, label, del, a, strong, em, li, dt, dd { white-space:normal;word-break:break-word; }-->
<!--input{border:0;background:none;}-->
<!--table, tr, th, td { /* border: 0 none; */ padding: 4px; border-collapse:collapse; border-spacing:0; }-->
<!--fieldset { border:0 none; }-->
<!--button { cursor: pointer; }-->
<!--a, a:link { color: #666666;text-decoration:none; cursor: pointer; border:0; }-->
<!--a:hover, a:active { text-decoration: none; }-->
<!--a:focus,input,textarea { outline: none; }-->
<!--a{ blr:expression(this.onFocus=this.blur()); /* IE Opera */ outline:none; /* FF Opera */ }-->
<!--a:focus{ -moz-outline-style: none; /* FF */ }-->
<!--.clearfix { overflow: hidden; zoom: 1 }-->
<!--.clear:after{content: ".";display: block;height:0;clear: both;visibility: hidden;overflow: hidden;}-->
<!--.hide{display: none!important;}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/components/public/LabHeader.vue